// extracted by mini-css-extract-plugin
module.exports = {"wrap_layout":"layout_wrap_layout__189Bd","wrapper":"layout_wrapper__2y3GH","main":"layout_main__1Jw5L","main_inner":"layout_main_inner__WDRdd"};